import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import { GetTracking } from "../../store/actions/kalapost";
import { toggleSidebar } from "../../store/actions/layout";
import { canTypeForNumInput } from "../../utils/numbers";
import { errorMessage } from "../../utils/message";

const Tracking = () => {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const { executeRecaptcha } = useGoogleReCaptcha();

   const { trackingNumber } = useParams();
   const { isSidebarOpened } = useSelector((state) => state.layout);

   const [tracking, setTracking] = useState(trackingNumber || "");
   const [dataTracking, setDataTracking] = useState({ data: null, status: false });
   const [loading, setLoading] = useState(false);

   useEffect(() => {
      window.scrollTo(0, 0);
      setTracking(trackingNumber || "");

      const getTrack = async () => {
         if ((trackingNumber || "").toString().trim()) {
            setLoading(true);
            const token = await handleReCaptchaVerify();
            const res = await GetTracking(tracking, token);
            setLoading(false);

            if (res.status) {
               navigate(`/tracking/${tracking}`);
               setDataTracking({ data: res.data, status: true });
            } else {
               setDataTracking(prev => ({ ...prev, status: false }));
            }
         }
      };
      getTrack();
   }, []);

   const handleTrack = async (e) => {
      e.preventDefault();
      if (tracking.toString().trim()) {
         setLoading(true);
         const token = await handleReCaptchaVerify();
         const res = await GetTracking(tracking.toString().trim(), token);
         setLoading(false);

         if (res.status) {
            navigate(`/tracking/${tracking}`);
            setDataTracking({ data: res.data, status: true });
         } else {
            setDataTracking(prev => ({ ...prev, status: false }));
         }
      } else {
         setDataTracking({ data: null, status: false });
         errorMessage("لطفا کد رهگیری را وارد نمایید");
      }
   };
   const handleReCaptchaVerify = useCallback(async () => {
      if (!executeRecaptcha) {
         return;
      }

      const token = await executeRecaptcha();
      return token;
   }, [executeRecaptcha]);


   return (
      <main
         className="main main--tracking"
         onClick={() => isSidebarOpened && dispatch(toggleSidebar())}
      >
         <div className="otracking">
            <div className="otracking__text">
               <h2 className="otracking__text-title">رهگیری</h2>
               <p className="otracking__text-explanation">
                  درصورتی که می خواهید از آخرین وضعیت مرسوله اطلاع یابید، کد رهگیری را
                  درفیلد مربوطه وارد کنید
               </p>
            </div>

            <form onSubmit={handleTrack} className="otracking__box">
               <input
                  type="text"
                  className="otracking__box-input"
                  placeholder="کد رهگیری "
                  value={tracking}
                  onChange={(e) => setTracking(e.target.value)}
                  onKeyDown={canTypeForNumInput}
               />
               <button
                  type="submit"
                  className="btn btn--Primary btn--Primary-tracking"
               >
                  رهگیری
               </button>
            </form>
         </div>

         {loading && (
            <div className="spinner">
               <img src="/img/spinner.gif" alt="" />
            </div>
         )}

         {dataTracking.status && (
            <div className="send" id="send">
               <div className="date">
                  <p className="date__destination">{dataTracking?.data?.status}</p>
                  <div className="date__time">
                     <p className="date__day">{dataTracking?.data?.updatedDate}</p>
                     <p className="date__hour">ساعت {dataTracking?.data?.updatedTime}</p>
                  </div>
               </div>
               <div className="information">
                  <p className="information__goods">اطلاعات مرسوله</p>
                  <ul className="information__lists">
                     <li className="information__item">
                        روش ارسال :<p>ارسال با اتوبوس</p>
                     </li>
                     <li className="information__item">
                        زمان سفارش :
                        <p>
                           {dataTracking?.data?.orderDate} ساعت{" "}
                           {dataTracking?.data?.orderTime}
                        </p>
                     </li>
                     <li className="information__item">
                        فرستنده :<p>{dataTracking?.data?.senderName}</p>
                     </li>
                     <li className="information__item">
                        شهر مقصد :<p>{dataTracking?.data?.destination}</p>
                     </li>
                     <li className="information__item">
                        گیرنده :<p>{dataTracking?.data?.recipientFullName}</p>
                     </li>
                     <li className="information__item">
                        هزینه ارسال :<p>{dataTracking?.data?.price} ریال</p>
                     </li>
                     <li className="information__item">
                        هزینه خدمات :<p>{dataTracking?.data?.serviceFee} ریال</p>
                     </li>
                     <li className="information__item">
                        نوع پرداخت :<p>{dataTracking?.data?.paymentTime}</p>
                     </li>
                  </ul>
               </div>
               {/* <div className="detail">
            <p className="detail__message">
              درصورتی که شما ارسال کننده کالا هستید برای مشاهده جزییات و دریافت
              رسید وارد سایت شوید
            </p>
            <button className="detail__btn">مشاهده جزییات</button>
          </div> */}
            </div>
         )}
         <Link
            to="/order"
            className="main__Send-package"
         >
            <img className="main__Send-package-img" src="/img/postfix.png" alt="" />
            <h4>ارسال بسته</h4>
         </Link>
      </main>
   );
};

export default Tracking;
